<template>
  <div class="home">
    <!-- 登录弹出框 -->
    <div class="login_show" v-if="show_login">
      <div class="login_view">
        <login @login_ok="login_ok" :logintype="logintype"></login>
      </div>
    </div>
    <!-- 顶部信息栏 -->
    <div class="title" style="display: flex; justify-content: space-between">
      <div class="header_view">
        <div style="display: flex; align-items: center">
          <img style="height: 48px" :src="coverImageStr(roomconfig.sharePicUrl)" alt="" />
          <div class="liveName">{{ roomconfig.roomName }}</div>
          <div class="tag"><span
              :class="['dito', roomconfig.liveStatus == 'living' ? 'living' : 'awaiting']"></span><span>{{
                roomconfig.liveStatus == 'living' ? '直播中' : '未开始' }}</span>
          </div>
          <div style="margin-left: 25px; color: #666; font-size: 12px" v-if="
            roomconfig.decisionNumberDTO.showType == 'times' ||
            roomconfig.decisionNumberDTO.showType == 'online'
          ">
            <i class="el-icon-user-solid" color="#666"></i>
            <span style="margin-left: 5px" v-if="roomconfig.decisionNumberDTO.showType == 'times'">{{
              roomconfig.decisionNumberDTO.baseLine + IMObject.userCount
            }}</span>
            <span style="margin-left: 5px" v-else="roomconfig.decisionNumberDTO.showType == 'online'">
              {{
                (roomconfig.decisionNumberDTO.baseLine - 0) * IMObject.userCount
              }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 直播容器 -->
    <div :class="['view_box', decorateMenuDTO.length < 1 ? 'view_box_full' : '']">
      <div class="lives">
        <!-- 显示倒计时 -->
        <div class="daojishi" v-if="!show_play && show_countdown">
          <div class="djs_tips">
            <img src="../assets/lives/leftd.png" alt="" />
            <span>直播倒计时</span>
            <img src="../assets/lives/rightd.png" alt="" />
          </div>
          <countdown @countdown_show="countdown_show" :endTime="new Date(roomconfig.beginTime).getTime()"
            :endText="'即将开始'">
          </countdown>
        </div>
        <!-- 直播播放器 -->
        <div class="live_player" :style="`background-image: url(${roomconfig.roomMainPic != '' ? roomconfig.roomMainPic : zbfm
          });background-position: center;background-repeat: no-repeat;background-size: 100%;`">
          <div id="playerWapper" v-show="!tc_show"></div>
          <!-- 跑马灯 -->
          <!-- <div class="tc_pmd">
            <vue-seamless-scroll :data="listData" :class-option="classOption" @ScrollEnd="ScrollEnd" class="paomadeng"
              style="text-align: right;width:98%;" v-if="roommarquee.marqueeEnable && show_play">
              <div style="width:100vw;color: #000;font-size: 14px;" id="pmddiv1" :style="changeStyle">
                <span>{{ roommarquee.customContent }}</span>
              </div>
            </vue-seamless-scroll>
          </div> -->
          <div id="tc_player"></div>


          <!-- 抢购弹窗 -->
          <recommend :style="{ zIndex: new Date().getTime() - 1741763154594 }" @excitrecommend="excitrecommend"
            v-if="show_recommend" :recommend_info="recommend_info" @recommendSucess="recommendSucess"
            :buyButtonText="goodsText.buyButtonText" :productSoldOutDesc="goodsText.productSoldOutDesc"></recommend>



        </div>
        <!-- 视频播放器 -->
        <!-- 暂无直播 -->
        <!-- <div class="nolive" v-if="!show_play && noLiving">暂无直播</div> -->
        <!-- 点击付费 -->
        <div class="s_freetips" v-if="show_freetips">
          您正在观看付费直播间内容，付费可解锁全部内容。<span style="color: #256ee7; margin-left: 8px; cursor: pointer"
            @click="show_login = true">立即支付</span>
        </div>
        <!-- 课程名称切换线路 -->


      </div>
      <!-- 消息容器 -->
      <div class="message_view">
        <transition name="el-collapse-transition">
          <message @showSign="showSign" @closeSign="closeSign" v-show="!showcommodity && !show_privatesms"
            @clickcommodity="commodity_show" :liveStatus="roomconfig.liveStatus" @clickcustomer="callcustomer"
            @clickreward="clickreward" @clickprivatesms="clickprivatesms" :roomconfig="roomconfig"
            :name_type="name_type" :title="ImMenuTitle" :login_type="logintype" @room_lookbase="room_lookbase"
            ref="message_child" @liveForceLogout="liveForceLogout" @recommend_dec="recommend_dec"
            @openNotice="openNotice" @ImUserNumber="ImUserNumber" :buyButtonText="goodsText.buyButtonText"
            @excitrecommend="excitrecommend" :productSoldOutDesc="goodsText.productSoldOutDesc" @stoplive="stoplive"
            @openLive="openLive">
          </message>
        </transition>
        <!-- 商品列表 -->
        <commodity ref="commodity" v-show="showcommodity" @excitvcommodity="commodity_show" :roomId="roomconfig.roomId"
          :buyButtonText="goodsText.buyButtonText" :productSoldOutDesc="goodsText.productSoldOutDesc"
          @recommend_dec="recommend_dec"></commodity>
        <!-- 公告弹窗 -->
        <!-- 通知弹窗 -->
        <!-- <notice v-if="shownotice" :noticeMessage="noticeMessage" @close="visibileNotice(false)"></notice> -->
        <!-- 私聊列表 -->
        <privatesms v-show="show_privatesms" @excitprivatesms="clickprivatesms"></privatesms>
      </div>
    </div>
    <!-- 课程介绍 -->
    <div v-if="decorateMenuDTO.length > 0">
      <div class="room-info">
        <div class="tabs">
          <span :class="['tabmenu', selectMenu == i ? 'active_menu' : '']" v-for="(item, i) in decorateMenuDTO" :key="i"
            @click="selectMenu = i">{{ item.menuName }}</span>
        </div>
        <div class="desc" v-if="decorateMenuDTO[selectMenu].userDefinedType == 'url'">
          <!-- <a :href="decorateMenuDTO[selectMenu].menuUrl">{{ decorateMenuDTO[selectMenu].menuUrl }}</a> -->
          <iframe :src="decorateMenuDTO[selectMenu].menuUrl"
            style="width: 100%; height: 900px; border: none; overflow-y: hidden"></iframe>
        </div>
        <div class="desc" v-else="decorateMenuDTO[selectMenu].userDefinedType == 'imageText'"
          v-html="decorateMenuDTO[selectMenu].menuDesc"></div>
      </div>
    </div>
    <!-- 客户 -->
    <!-- <customer v-if="call_customer" @excitcustomer="callcustomer" style="z-index: 1012;"></customer> -->
    <!-- 打赏 -->
    <!-- <reward v-if="show_reward" @excitreward="clickreward" style="z-index: 1011;"></reward> -->
    <!-- 商品推荐 -->
    <!-- <recommend style="z-index: 1010;" @excitrecommend="excitrecommend" v-if="show_recommend"
      :recommend_info="recommend_info" @recommendSucess="recommendSucess"></recommend> -->
    <!-- 通知弹窗 -->
    <notice v-if="shownotice" :noticeMessage="noticeMessage" @close="shownotice = false"></notice>
    <!-- 签到 -->
    <sign ref="sign"></sign>


    <!-- 非学员提示  -->
    <el-dialog title="提示" :visible.sync="show_not_ver" width="30%" :close-on-click-modal="false"
      :before-close="close_lives" center>
      <span>您不是该课程学员，请通过班课认证后再进入直播间</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close_lives">取 消</el-button>
        <el-button type="primary" @click="close_lives">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 切换线路弹窗 -->
    <el-dialog title="线路切换" :visible.sync="choose_url" width="400px" :before-close="close_choose_url" center>
      <template>
        <div>
          <el-radio v-model="radio" label="1" border style="margin-left: 35px">线路1</el-radio>
          <el-radio v-model="radio" label="3" border size="medium" style="margin-left: 20px">标准直播</el-radio>
        </div>
        <div style="margin-top: 25px">
          <el-radio v-model="radio" label="2" border style="margin-left: 35px">线路2</el-radio>
          <el-radio v-model="radio" label="4" border size="medium" style="margin-left: 20px"
            v-if="show_lowicon">快直播</el-radio>
        </div>
      </template>
      <span slot="footer" class="dialog-footer">
        <el-button @click="choose_url = false">取 消</el-button>
        <el-button type="primary" @click="switch_url">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 企微绑定 -->
    <bindWxUser :visible="bindwxuser" :data="bindwxuserData" @close="bindwxuser = false"></bindWxUser>
    <!--白名单校验 -->
    <div class="watch_type" v-if="accountValidate">
      <div v-if="Whitelist">
        <!-- <div style="overflow: hidden">
          <i class="el-icon-close" style="float: right; font-size: 18px; cursor: pointer"
            @click="accountValidate = false"></i>
        </div> -->
        <div class="t_title">账号验证</div>
        <div class="t_input">
          <el-input v-model="u_account" placeholder="请输入账号"></el-input>
        </div>
        <div class="t_if">
          <span style="color: #666">没有账号？</span><span style="color: #4256fb">请联系管理员</span>
        </div>
        <div class="t_button" @click="check_account">登录</div>
      </div>
    </div>

    <!--密码校验 -->
    <div class="watch_type" v-if="passwordValidate">
      <div v-if="passwordValidate">
        <div class="t_title">密码验证</div>
        <div class="t_input">
          <el-input v-model="password" placeholder="请输入密码"></el-input>
        </div>
        <div class="t_if">
          <span style="color: #666">没有密码？</span><span style="color: #4256fb">请联系管理员</span>
        </div>
        <div class="t_button" @click="check_password">登录</div>
      </div>
    </div>
    <!-- 报名观看 -->
    <singup v-if="show_signup" :roomConfig="roomconfig" @success="onSignupSuccess"></singup>


  </div>
</template>

<script>
import TCPlayer from 'tcplayer.js';
import message from "@/components/lives/message.vue";
import warelives from "@/components/lives/warelives.vue";
import commodity from "@/components/lives/commodity.vue";
import menuandvideo from "@/components/lives/menuandvideo.vue";
import customer from "@/components/lives/customer.vue";
import reward from "@/components/lives/reward.vue";
import Reward from "@/components/lives/reward.vue";
import privatesms from "@/components/lives/privatesms.vue";
import login from "@/components/livelogin/login.vue";
import lookcode from "@/components/lives/lookcode.vue";
import countdown from "@/components/lives/countdown";
import defaultCoverImage from "@/assets/lives/dlog.png";
import recommend from "@/components/lives/recommend.vue";
import notice from "@/components/lives/notice.vue";
import sign from "@/components/lives/sign.vue";
import singup from "@/components/lives/singup.vue";
import $ from "jquery";
import bindWxUser from "./bindWxUser.vue";
var player;
var tcPlayer = null;
var hlsJsPlayer;
var adm = 0;
var ilist = {
  i1: 0,
  i2: 0,
  i3: 0,
};
export default {
  name: "HomeView",
  components: {
    message,
    warelives,
    commodity,
    menuandvideo,
    customer,
    reward,
    Reward,
    privatesms,
    login,
    lookcode,
    recommend,
    notice,
    sign,
    countdown,
    bindWxUser,
    singup,
  },
  data() {
    return {
      showcommodity: false,
      call_customer: false,
      show_reward: false,
      show_recommend: false,
      show_privatesms: false,
      sendText: "",
      show_countdown: false,
      recommend_info: {},
      roomconfig: {
        decisionNumberDTO: {
          showType: "none",
        },
      },
      goodsText: {
        buyButtonText: "立即抢购",
        productSoldOutDesc: "已售罄",
        productCountdown: 0,
      },
      imHttpServerUrl: "",
      sensitiveWordList: [],
      usercount: 0,
      roomtaglsit: [],
      msgtags: {},
      name_type: "0",
      show_login: false,
      logintype: {},
      listData: [1],
      classOption: {
        limitMoveNum: 1,
        direction: 2,
        step: 1.5,
        hoverStop: false,
      },
      classOption2: {
        limitMoveNum: 1,
        direction: 2,
        step: 0.5,
        hoverStop: false,
      },
      roommarquee: {},
      changeStyle: {},
      free_time: 0,
      free: null,
      user_account: "",
      followinfo: {},
      lookurl: window.location.href,
      backinfo: {},
      show_play: false,
      show_player: true,
      player_refresh: false,
      show_pmd: false,
      show_ware: false,
      ware_size: 1,
      tc_show: false,
      show_freetips: false,
      up_second_times: null, //计  时器
      up_data_sceond: 0, //计时器
      check_live: true,
      show_not_ver: false,
      checkWatchTypeSuccess: true,
      q_config: {},
      radio: "1",
      choose_url: false,
      show_lowicon: false,
      roomwatchurl: {},
      kj_height: false,
      l_screenWidth: document.body.clientWidth,
      noLiving: false,
      // 企微绑定
      bindwxuser: false,
      bindwxuserData: {},
      accountValidate: false,
      passwordValidate: false,
      password: "",
      Whitelist: false,
      u_account: "",
      tc_player: false,
      decorateMenuDTO: [],
      ImMenuTitle: "互动聊天",
      selectMenu: 0,
      pullsUrl: [],
      ImLogin: false,
      IMObject: {
        userCount: 0,
      },
      noticeMessage: {},
      shownotice: false,
      show_signup: false,
    };
  },
  computed: {
    coverImageStr() {
      return (value) => {
        return value
          ? value
          : this.q_config.logo
            ? this.q_config.logo
            : defaultCoverImage;
      };
    },
  },
  async created() {
    try {
      // 获取配置
      const res = await this.$liveapi.roomconfig();
      // 直播间详情
      this.roomconfig = res.data.data.liveRoomDetailDTO;
      // this.imHttpServerUrl =
      //   res.data.data.merchantConfigDetailDTO.imHttpServerUrl;
      // this.sensitiveWordList = res.data.data.sensitiveWordDTO.wordList;
      this.pullsUrl = (res.data.data.liveRoomUrlDTO.pullsUrl || []).filter(
        (url) => !String(url).toLowerCase().startsWith("rtmp://")
      );
      // 直播id
      sessionStorage.setItem("live_id", this.roomconfig.roomId);
      //商户id
      localStorage.setItem(
        `${this.$route.params.id}c_id`,
        this.roomconfig.merchantId
      );
      // 自定义菜单
      if (res.data.data.liveRoomDetailDTO.decorateMenuDTO.length > 0) {
        res.data.data.liveRoomDetailDTO.decorateMenuDTO.forEach((element) => {
          if (element.menuType != 1) {
            this.decorateMenuDTO.push(element);
          } else {
            this.ImMenuTitle = element.menuName;
          }
        });
      }

      // 商品字段参数
      this.goodsText.buyButtonText = !this.roomconfig.productBuyButtonText
        ? "立即抢购"
        : this.roomconfig.productBuyButtonText;
      this.goodsText.productSoldOutDesc = !this.roomconfig.productSoldOutDesc
        ? "已售罄"
        : this.roomconfig.productSoldOutDesc;
      this.goodsText.productCountdown = this.roomconfig.productCountdown == -1
        ? 0
        : this.roomconfig.productCountdown;

      // 设置直播背景
      document.title = this.roomconfig.roomName;
      // this.setRoomMainPic()
      if (!localStorage.getItem("user_token_" + this.roomconfig.merchantId)) {
        //没有token登录
        this.show_login = true;
      } else {
        //校验token
        const res = await this.$liveapi.livechecktoken();
        // tonken有效
        if (res.data.data.stats == "1") {
          // 校验白名单
          if (this.roomconfig.enterType == "WHILE_LIST") {
            const resolve = await this.$liveapi.checkUser();
            if (resolve.data.data.status === 0) {
              this.accountValidate = true;
              this.Whitelist = true;
            } else if (resolve.data.data.status === 1) {
              debugger

              // if (resolve.data.data.showName.trim() != "" && resolve.data.data.showName != null && resolve.data.data.showName != undefined) {
              //   localStorage.setItem("user_name", resolve.data.data.showName);
              // }
              this.setRoomBase();
            }
          }
          if (this.roomconfig.enterType == 'PASS_WORD') {

            const { data } = await this.$liveapi.checkPassWord();
            if (data.msg == '密码校验未登录') {
              this.passwordValidate = true;
            } else {
              this.setRoomBase();
            }

          } if (this.roomconfig.enterType == 'SIGNUP') {
            const { data } = await this.$liveapi.querySignedUp({ roomId: this.roomconfig.roomId });
            if (!data.data) {
              this.show_signup = true;
            } else {
              this.setRoomBase();
            }
          }
          else if (this.roomconfig.enterType == "FREE" || this.roomconfig.enterType == 'API_AUTH') {
            this.setRoomBase();
          }
          this.getSign()
        } else {
          // 登录过期重新登录
          this.show_login = true;
        }
      }
    } catch (err) {

    }
  },

  methods: {
    // 校验白名单
    async check_account() {
      try {
        const res = await this.$liveapi.checkAccount(this.u_account);
        if (res.data.code === 0) {
          if (res.data.data.showName != "") {
            localStorage.setItem("user_name", res.data.data.showName);
          }
          this.accountValidate = false;
          this.Whitelist = false;
          this.setRoomBase();
        }
      } catch (error) {

      }
    },
    async check_password() {
      if (this.password == '') {
        this.$message.error('请输入密码');
        return;
      }
      const res = await this.$liveapi.roomwatchytypeencryption(this.password);
      if (res.data.code === 0) {
        this.passwordValidate = false;
        this.setRoomBase();
      }
    },
    onSignupSuccess() {
      this.show_signup = false;
      this.setRoomBase();
    },
    // 设置直播间基础数据
    setRoomBase() {
      // 获取商品列表
      this.$refs.commodity.getroomcommodityinfo();
      this.getRecommendCommodityInfo()
      // 获取推荐商品
      // 播放直播
      if (this.roomconfig.liveStatus == "living") {
        this.show_play = true;
        this.inittcplayer(this.pullsUrl, "live");
      } else {
        // 开启回放且 在有效时间内地址不为空
        if (
          this.roomconfig.replayFlag === 1 &&
          (new Date(this.roomconfig.replayLimitCondition) > new Date() ||
            !this.roomconfig.replayLimitCondition)
        ) {
          if (
            this.roomconfig.replayVideoInfoDTO.url != "" &&
            this.roomconfig.replayVideoInfoDTO.url != null
          ) {
            this.inittcplayer(
              [{ src: this.roomconfig.replayVideoInfoDTO.url }],
              "video"
            );
          } else if (this.roomconfig.countdownFlag === 1) {
            this.show_countdown = true;
          } else {
            this.noLiving = true;
          }
        } else {
          // 没有开启回放
          if (this.roomconfig.countdownFlag === 1) {
            this.show_countdown = true;
          } else {
            this.show_countdown = false;
          }
        }
      }

      // 登录IM
      this.$refs.message_child.socketLogin();
    },

    // 获取签到
    getSign() {
      let _this = this;
      this.$liveapi.needsign({ roomId: this.roomconfig.roomId }).then((res) => {

        if (res.data.data != null) {
          _this.$refs.sign.showSign({
            statId: res.data.data.statId,
            timeOut:
              res.data.data.createTime + res.data.data.signInTime * 60 * 1000,
            sendTime: res.data.data.createTime,
          });
        }
      });
    },

    closeSign() {
      this.$refs.sign.close();
    },
    showSign(msg) {
      this.$refs.sign.showSign(msg);
    },
    // 开播停播
    openLive(status) {
      console.log('开播停播', status)
      let _this = this;
      if (status == 1) {
        _this.$liveapi.fillBaseUser({ termId: _this.roomconfig.termId }).then(res => {
          console.log('开播上报', res)
        })
      }



      if (status == 1 && this.roomconfig.liveStatus !== "living") {
        // 开播
        this.roomconfig.liveStatus = "living";
        this.show_play = true;
        if (tcPlayer) {
          tcPlayer.dispose();
          tcPlayer = null;
        }
        _this.inittcplayer(_this.pullsUrl, "live");
      } else if (status == 0 && this.roomconfig.liveStatus == "living") {
        this.roomconfig.liveStatus = "awaiting";
        if (tcPlayer) {
          tcPlayer.dispose();
          tcPlayer = null;
        }
        // 停止播放
        if (
          this.roomconfig.replayFlag === 1 &&
          (new Date(this.roomconfig.replayLimitCondition) > new Date() ||
            !this.roomconfig.replayLimitCondition)
        ) {
          if (
            this.roomconfig.replayVideoInfoDTO.url != "" &&
            this.roomconfig.replayVideoInfoDTO.url != null
          ) {

            this.inittcplayer(
              [{ src: this.roomconfig.replayVideoInfoDTO.url }],
              "video"
            );
          } else if (this.roomconfig.countdownFlag === 1) {
            this.show_countdown = true;
          } else {
            this.noLiving = true;
          }
        } else {

          if (this.roomconfig.countdownFlag === 1) {
            this.show_countdown = true;
          } else {
            this.show_countdown = false;
          }
        }
      }
     
    },
    //倒计时显示
    countdown_show(status) {
      this.show_countdown = status;
    },
    // 线路切换
    switch_url() { },
    //关闭线路选择
    close_choose_url() {
      this.choose_url = false;
    },

    //停止直播
    close_lives() {
      player.dispose();
      this.show_not_ver = false;
    },

    callcustomer(val) {
      this.call_customer = val;
    },
    clickreward(val) {
      this.show_reward = val;
    },
    clickprivatesms(val) {
      this.show_privatesms = val;
    },
    login_ok(val) {
      this.show_login = val;
    },

    //
    room_lookbase(val) {
      this.usercount = val;
    },
    // 设置推荐
    set_recommend_info(goods) { },

    //生成房间token
    getusertoken() { },
    //点播视频
    show_play_updata(val) {
      if (hlsJsPlayer) {
        hlsJsPlayer.destroy();
      }
    },

    //开启免费观看
    setPlayFreeTime(type) {
      var that = this;
      this.free_time = type.freetime * 60;
      this.show_freetips = true;
      if (this.free_time == 0) {
        this.show_login = true;
        this.show_freetips = false;
        this.$refs.message_child.nosms();
        if (tcPlayer) {
          tcPlayer.dispose();
          tcPlayer = null;
        }
        if (player) {
          player.dispose();
        }
        if (hlsJsPlayer) {
          hlsJsPlayer.destroy();
        }
        localStorage.removeItem(
          "free" + localStorage.getItem(this.$route.params.id + "c_id")
        );
      } else {
        var localfree = localStorage.getItem(
          "free" + localStorage.getItem(this.$route.params.id + "c_id")
        );
        if (localfree && localfree <= this.free_time) {
          this.free_time = localStorage.getItem(
            "free" + localStorage.getItem(this.$route.params.id + "c_id")
          );
        }
        this.free = setInterval(() => {
          if (that.free_time <= 0) {
            clearInterval(that.free);
            setTimeout(() => {
              if (tcPlayer) {
                tcPlayer.dispose();
                tcPlayer = null;
              }
              if (player) {
                player.dispose();
              }
            }, 500);
            //录播是否存在
            if (hlsJsPlayer) {
              hlsJsPlayer.destroy();
            }
            this.show_login = true;
            //设置了免费观看时间
            if (type.freetime > 0) {
              this.$message({
                message: "免费观看时间结束，如需继续观看，请扫码支付",
                type: "warning",
              });
            }
            this.show_freetips = false;
            return;
          }
          --this.free_time;
          localStorage.setItem(
            "free" + localStorage.getItem(this.$route.params.id + "c_id"),
            this.free_time
          );
        }, 1000);
      }
    },

    //设置跑马灯
    getroommarquee() {
      if (this.roomconfig.horseRaceLampMode == 2) {
        this.changeStyle = {
          color: this.roomconfig.horseRaceLampColor,
          "font-size": this.roomconfig.horseRaceLampSize + "px",
        };
        var rollSpeed = this.roomconfig.horseRaceLampSpeed;
        this.classOption.step =
          rollSpeed == 50 ? 0.8 : rollSpeed == 40 ? 1.6 : 2.4;
        if (this.roomconfig.horseRaceLampType == 1) {
          this.roommarquee.customContent = localStorage.getItem("user_name");
          if (
            localStorage.getItem("iswx") == 0 &&
            localStorage.getItem("logtpye") == 4
          ) {
            this.roommarquee.customContent = localStorage.getItem("user_name1");
          }
        }
      } else {
        if (this.roomconfig.horseRaceLampType == 1) {
          this.roommarquee.customContent = localStorage.getItem("user_name");
          if (
            localStorage.getItem("iswx") == 0 &&
            localStorage.getItem("logtpye") == 4
          ) {
            this.roommarquee.customContent = localStorage.getItem("user_name1");
          }
        }
      }
    },

    //生成随机数
    randomRange(min, max) {
      // min最小值，max最大值
      return Math.floor(Math.random() * (max - min)) + min;
    },

    //更换跑马灯位置
    ScrollEnd(e) {
      var p = document.querySelector(".paomadeng");
      p.style.marginTop = this.randomRange(0, 68) + "vh";
      p.style.display = "bolck";
    },

    ScrollEnd2(e) {
      var p = document.querySelector(".paomadeng3");
      p.style.marginTop = this.randomRange(0, 10) + "%";
      p.style.display = "bolck";
    },
    //暂停直播
    stoplive() {
      if (tcPlayer) {
        tcPlayer.dispose();
        tcPlayer = null;
      }
      // if (hlsJsPlayer != undefined) {
      //   hlsJsPlayer.pause()
      // }
    },
    //恢复直播
    playlive() {
      if (player != undefined) {
        player.play();
      }
      if (hlsJsPlayer != undefined) {
        hlsJsPlayer.play();
      }
    },
    //腾讯播放器实例
    inittcplayer(src, type) {
      let _this = this
      var txopts = {
        autoplay: type === "live" ? true : false,
        loop: false,
        sources: src,
        reportable: true,
        controlBar: {
          volumePanel: true,
          playToggle: type === "live" ? false : true,
          progressControl: type === "live" ? false : true,
          durationDisplay: type === "live" ? false : true,
          currentTimeDisplay: type === "live" ? false : true,
          timeDivider: type === "live" ? false : true,
          fullscreenToggle: false,
          QualitySwitcherMenuButton: false,
          playbackRateMenuButton: type === "live" ? false : true,
        },
        plugins: {
          // DynamicWatermark: {
          //   content: '你好我有凉了个帽衫',
          //   fontSize: '22px',
          //   color: 'red',
          //   speed: 0.2,
          // }
        },
      };
      this.tc_show = true;
      this.tc_player = true;
      $("#tc_player").html(
        '<video id="player-container-id"  style="width: 100%; height: 100%;"></video>'
      );
      tcPlayer = TCPlayer("player-container-id", txopts);

      let lastRecoverAt = 0;
      let lastRecoverTargetTime = -1;
      const recoverSeekToNextFrame = function (reason) {
        if (type !== "video" || !tcPlayer) {
          return;
        }
        const now = Date.now();
        // 避免短时间内多次触发异常导致频繁跳转
        if (now - lastRecoverAt < 500) {
          return;
        }
        lastRecoverAt = now;
        const currentTime = Number(tcPlayer.currentTime()) || 0;
        const duration = Number(tcPlayer.duration()) || 0;
        // 0s 首帧异常时也要继续往后跳，避免一直卡在起始帧
        const recoverBaseTime = Math.max(currentTime, lastRecoverTargetTime, 0);
        let nextTime = recoverBaseTime + 5;
        if (duration > 0 && !Number.isNaN(duration)) {
          nextTime = Math.min(nextTime, Math.max(duration - 0.5, 0));
        }
        if (nextTime <= recoverBaseTime) {
          return;
        }
        try {
          console.warn("[tcplayer recover]", reason, "seek to:", nextTime);
          lastRecoverTargetTime = nextTime;
          tcPlayer.currentTime(nextTime);
          tcPlayer.play();
        } catch (e) {
          console.error("[tcplayer recover failed]", e);
        }
      };

      tcPlayer.on("canplay", function () {
        if (type === "live") {
          tcPlayer.play();
        }
      });


      tcPlayer.on('ended', function () {
        if (type === "video") {
          localStorage.setItem(_this.roomconfig.roomId + '_' + _this.roomconfig.replayVideoInfoDTO
            .id + "play_time", 0)
        }
      });

      tcPlayer.on('play', function (error) {
        // 做一些处理
        if (type === "video") {
          if (localStorage.getItem(_this.roomconfig.roomId + '_' + _this.roomconfig.replayVideoInfoDTO.id + "play_time") != null) {
            tcPlayer.currentTime(localStorage.getItem(_this.roomconfig.roomId + '_' + _this.roomconfig.replayVideoInfoDTO.id + "play_time") - 0)
          }

        }
      });

      tcPlayer.on('pause', function (error) {
        // 做一些处理
        if (type === "live") {
          tcPlayer.play();
        }
      });

      tcPlayer.on('timeupdate', function (error) {
        if (type === "video") {
          localStorage.setItem(_this.roomconfig.roomId + '_' + _this.roomconfig.replayVideoInfoDTO.id + "play_time", tcPlayer.currentTime())
        }
      });

      tcPlayer.on("error", function (error) {
        recoverSeekToNextFrame("error");
      });
      tcPlayer.on("stalled", function () {
        recoverSeekToNextFrame("stalled");
      });
      tcPlayer.on("waiting", function () {
        recoverSeekToNextFrame("waiting");
      });
      // let videoDom = document.getElementById("player-container-id");
      // let springFrame = document.getElementsByClassName(
      //   "vjs-menu tcp-right-click-popup-menu"
      // )[0];
      // // springFrame.style.display = 'none'
      // //在这里你就可以自己定义事件的函数啦
      // videoDom.onmouseup = function (oEvent) {
      //   if (!oEvent) oEvent = window.event;
      //   if (oEvent.button == 2) {
      //     // setTimeout(() => {
      //     springFrame.textContent = "";
      //     // },
      //     // 1000)
      //   }
      // };
    },

    liveForceLogout() {

      //  tcPlayer.pause()
      //  tcPlayer.unload()
      // this.liveEnd();
      // 销毁播放器
      tcPlayer.dispose();
      tcPlayer = null;
      //  unload()  停止播放
    },
    // 推挤商品
    recommend_dec(recommend) {
      this.recommend_info = recommend;
      if (recommend.productSellOutStatus !== 'selloutIng') {
        this.show_recommend = true;
      }
    },
    // 公告弹窗
    openNotice(Notice) {
      this.noticeMessage = Notice
      this.shownotice = true
    },
    clickrecommend(val) {
      this.show_recommend = val;
    },
    recommendSucess() {
      this.show_recommend = false;
    },
    excitrecommend(val) {
      this.show_recommend = val;
    },
    //显示商品列表
    commodity_show(val) {
      this.showcommodity = val;
    },
    // IM推送消息
    ImUserNumber(number) {
      this.IMObject.userCount = number;
    },

    // 获取推荐商品
    getRecommendCommodityInfo() {
      let _this = this
      this.$liveapi.getRecommendCommodityInfo().then(res => {
        if (res.data.data.productId != null) {
          let exts = JSON.parse(res.data.data.exts)
          if ('timeOut' in exts) {
            res.data.data.endTime = exts.timeOut
          }
          res.data.data.sendTime = exts.sendTime
          if ('styleType' in exts) {
            res.data.data.styleType = exts.styleType
          } else {
            res.data.data.styleType = 1
          }
          if ("heat" in exts) {
            res.data.data.heat = exts.heat;
          }
          // 扩展字符
          if (('timeOut' in exts) && this.isGreater(exts.timeOut)) {
            _this.recommend_dec(res.data.data)
          } else {
            _this.recommend_dec(res.data.data)
          }
        }

      })
    }


  },
};
</script>
<style scoped>
.home {
  background-color: #000;
  padding-bottom: 4vh;
  /* padding-top: 20px; */
  background: #f5f8fc;
  padding: 0 40px;
  min-height: 100vh;
  /* overflow: hidden; */
}

.paomadeng3 {
  position: absolute;
  z-index: 999;
  width: 22.5%;
  overflow: hidden;
}

.view_box {
  width: 100%;
  height: calc(100vh - 120px);
  /* margin: 40px auto; */
  overflow: hidden;
  display: flex;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.21);
}

.view_box_full {
  height: calc(100vh - 102px);
}

.title {
  height: 54px;
  background-color: #f5f8fc;
}

.tc_pmd {
  height: 70vh;
  width: 68vw;
  position: absolute;
  top: 14vh;
  pointer-events: none;
  z-index: 99;
}

.test222 {
  height: 70vh;
  width: 68vw;
  position: absolute;
  z-index: 99;
  top: 14vh;
}

.view_live {
  height: 90vh;
  width: 90vw;
  margin-top: 40px;
}

.lives {
  height: 100%;
  width: 76%;
  /* padding-bottom: 54px; */
  box-sizing: border-box;
  background: #282828;
  position: relative;
}

.message_view {
  float: left;
  width: 24%;
  height: 100%;
  /* border-radius: 5px; */
}

.header_view {
  display: flex;
  flex: 1;
  height: 54px;
  align-items: center;
  justify-content: space-between;
}

.title .right {
  width: 24%;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  line-height: 54px;
}

.s_freetips {
  font-size: 17px;
  color: #fff;
  border-color: rgba(0, 0, 0, 0.4);
  position: absolute;
  bottom: 16%;
  left: 5%;
}

.header_view .tag {
  font-size: 12px;
  color: #333333;
  margin-left: 15px;
  font-weight: bold;
}

.header_view .tag .dito {
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-right: 5px;
  border-radius: 50%;
  margin-left: 5px;
}

.living {
  background: #FF5D5D;
}

.awaiting {
  background: #999;
}

.header_view .tag {
  /* width: 44px;
  height: 20px;
  font-size: 14px;
  border: 1px solid #ec4962;
  border-radius: 5px;
  text-align: center;
  color: #ec4962; */
}

.header_view>div:nth-child(4)>div {
  float: left;
  line-height: 70px;
}

.title_right>div {
  margin-left: 52px;
}

.title_right img {
  width: 24px;
  height: 24px;
  vertical-align: middle;
  margin-right: 12px;
}

.title_right span {
  font-size: 14px;
  color: #256ee7;
}

.live_player {
  height: 100%;
  width: 100%;
  background-color: #101010;
  background-position: center;
  background-size: 100%;
  background-repeat: no-repeat;
  /* border-radius: 5px; */
  overflow: hidden;
  position: relative;
}

#tc_player {
  width: 100%;
  height: 100%;
}

.liveName {
  font-size: 18px;
  font-weight: bold;
}

/* .live_until div {
  color: #D6DFFF;
  font-size: 14px;
  margin-right: 36px;
} */

.live_until img {
  vertical-align: middle;
  margin-right: 8px;
  margin-top: -3px;
}

.login_show {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1500;
  background-color: rgba(0, 0, 0, 0.4);
}

.login_view {
  width: 370px;
  height: 392px;
  background: #ffffff;
  border-radius: 10px;
  margin: 20vh auto;
}

.paomadeng {
  z-index: 100;
  width: 100%;
  padding: 5px 0px;
  position: absolute;
  overflow: hidden;
  color: #fff;
}

.paomadeng1 {
  z-index: 100;
  width: 100%;
  padding: 5px 0px;
  position: absolute;
  top: 0;
  overflow: hidden;
  color: #fff;
}

.paomadeng2 {
  z-index: 100;
  width: 100%;
  padding: 5px 0px;
  position: absolute;
  top: 0;
  overflow: hidden;
  color: #fff;
}

.shoujiguankan {
  cursor: pointer;
}

.shoujiguankan>div:nth-child(3) {
  display: none;
  position: absolute;
}

.shoujiguankan:hover>div:nth-child(3) {
  display: block;
}

.guanzhu>div:nth-child(3) {
  display: none;
  position: absolute;
}

.guanzhu:hover>div:nth-child(3) {
  display: block;
}

.daojishi {
  color: #fff;
  height: 100%;
  width: 100%;
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;
}

.djs_tips {
  margin-top: 300px;
  margin-bottom: 30px;
}

.djs_tips span {
  padding: 20px;
}

.daojishi img {
  vertical-align: middle;
}

.nolive {
  color: #fff;
  padding: 10px 20px;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 10px;
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.watch_type {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.6);
}

.watch_type>div {
  background-color: #fff;
  border-radius: 10px;
  margin: 8% auto;
  padding: 24px 35px 35px 35px;
  width: 316px;
  height: 289px;
  overflow: hidden;
}

.t_title {
  margin-top: 22px;
  font-size: 24px;
  font-weight: 550;
  text-align: center;
}

.t_tips {
  font-size: 16px;
  padding: 20px;
  text-align: center;
}

.t_input {
  margin-top: 52px;
  height: 46px;
  text-align: center;
}

.t_if {
  font-size: 14px;
  margin-top: 12px;
  text-align: right;
  cursor: pointer;
}

.t_button {
  margin-top: 40px;
  height: 46px;
  background: #e53256;
  border-radius: 10px;
  text-align: center;
  line-height: 46px;
  color: #fff;
  cursor: pointer;
}

.room-info {
  width: 100%;
  height: 50vh;
  margin-top: 25px;
  background: #fff;
}

.tabs {
  display: flex;
  padding: 0 8px;
}

.tabmenu {
  font-size: 16px;
  font-weight: bold;
  padding: 5px 4px;
  position: relative;
  margin-right: 30px;
}

.active_menu::after {
  position: absolute;
  content: "";
  width: 100%;
  height: 4px;
  border-radius: 2px;
  background: #694ec4;
  bottom: -5px;
  left: 0;
}

.desc {
  padding: 10px;
  padding-top: 30px;
  text-align: initial;
  word-break: break-word !important;
}


/* .desc * {
  word-break: break-word !important;
} */
</style>
